export default {
    home: '首页',
    incomeOverview: '收益统计',
    incomeList: '收益记录',
    login: '登录',
    open: '收银开单',
    openCard: '营销售卡',
    orderDetail: '订单详情',
    profitOrderDetail: '收益订单详情',
    orderEdit: '收银页面',
    orderList: '订单列表',
    // workerOrderList: '接车订单列表',
    // workerOrderDetail: '接车订单详情',
    storeCardEdit: '爱车卡销售',
    client: '车主管理',
    cars: '车辆管理',
    prePaid: '储值卡充值',
    prePaidEdit: '储值卡销售',
    clientPromot: '保养营销',
    prePaidRecord: '充值记录',
    clientDetail: '车主详情',
    pageNotFound: '404',
    systemMaintenance: '系统维护中',
    operators: '员工列表',
    staffEdit: '管理员编辑',
    staffList: '管理员列表',
    roleList: '角色管理',
    roleEdit: '角色编辑',
    notice: '系统通知',
    noticeDetail: '通知详情',
    logList: '操作日志',
    predict: '预测营销',
    prePaidCrt: '储值卡更正',
    printOrder: '打印订单',
    printStoreDetail: '打印订单',
    finishOrder: '批量完成挂账订单',
    historyList: '历史导入数据',
    selfGoods: '自营商品',
    selfGoodsEdit: '自营商品编辑',
    enterStoreDetail: '入库详情',
    outStoreDetail: '出库详情',
    agencyGoods: '代理商品',
    enterStore: '入库管理',
    outStore: '出库管理',
    serverReserve: '服务预约分析',
    dataOverview: '数据概览',
    analyseGoods: '商品分析',
    analyseRepairCard: '爱车卡分析',
    analyseSalesActivity: '营销活动分析',
    analyseStoreCard: '储值卡分析',
    analyseCustomer: '客户分析',
    carsInspectionTemplate: '车检模板',
    carsExamReport:'车检报告',
    addCarExam:'新增车检',
    serviceList: '门店服务列表',
    writeoffList: '核销记录',
    writeoffDetail: '核销详情',
    maintenancePlan: '保养方案',
    maintenanceRecord: '保养营销记录',
    maintenanceRecordDetails: '保养营销记录详情',
    couponList: '优惠券',
    couponOwner: '领券车主',
    couponLaunch: '发放优惠券',
    analyseCoupon: '优惠券分析',
    vipExplain: 'VIP续费升级',
    orderSetting: '订单设置',
    carHistoryOrderDetail: '车辆历史记录详情',
};



// WEBPACK FOOTER //
// ./src/router/pageTitle.js